<template>
    <div class="look">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>协议管理</el-breadcrumb-item>
            <el-breadcrumb-item>查看</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :model="upsertForm" size="mini"  ref="upsertForm" label-width="80px" style="margin-top: 20px;" >
            <input type="hidden" :value="upsertForm.id">
                      <el-form-item label="协议名称" prop="title">
                         {{upsertForm.title}}
                     </el-form-item>
                      <el-form-item label="协议内容" prop="content">
                         <div v-html="upsertForm.content"></div>
                     </el-form-item>
                      <el-form-item label="适用店面" prop="shopName">
                         {{upsertForm.shopName}}
                     </el-form-item>
                      <el-form-item label="链接" prop="url">
                         {{config.resIp+upsertForm.url}}
                     </el-form-item>
        </el-form>
        <div  class="dialog-footer" style="text-align: center;">
            <el-button class="large" size="mini" @click="close">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "lookSysAgreement",
        props: ['id'],
        data(){
            return {
                upsertForm:{
                        id:'',
                        title:'',
                        content:'',
                        shopId:'',
                        shopName:'',
                        url:'',
                        createTime:'',
                        updateTime:''
                },
                config:config
            }
        },
        created(){
          axios({
                url:`${home}/sysAgreement/look/lookSysAgreementById/${this.id}`,
                method:'GET'
            }).then(res=>{
                Object.assign(this.upsertForm,res.data);
            }).catch(error=>{
                console.log(error);
            })
        },
        mounted(){

        },
        methods:{
            close(){
                this.$emit('update:visible');
            }
        }
    }
</script>

<style scoped lang="scss">
    .look{
        width:60%;
        margin: 20px 0 0 10px;
    }
</style>
